const pushEventDataLayerObj = dataObj => {
  try {
    // trackEvent

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(dataObj)

    if (
      process.env.ENVIRONMENT === 'LOCAL' ||
      process.env.ENVIRONMENT === 'DEV'
    ) {
      console.log('=============PUSH  DATALAYER')
      console.log(dataObj)
      console.log('=============PUSH  DATALAYER')
    }
  } catch (e) {
    console.log('Datalayer Error')
  }
}
export default pushEventDataLayerObj
